@function hex-to-rgba($hex, $alpha: 1) {
  @return rgba(red($hex), green($hex), blue($hex), $alpha);
}

.messageRow {
  display: flex;
  width: 100%;

  .messageAndReactionsContainer {
    position: relative;
    display: flex;
    flex-direction: column;

    &.topZIndexForInlineActions {
      z-index: 99;
    }

    &:hover {
      .inlineActionsWrapper {
        display: flex;
        @include mobile() {
          display: none;
        }
      }
    }

    .messageRowNoReactions {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      gap: 8px;

      .senderAvatar {
        flex: 0 0 auto;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        margin-bottom: 4px;
        border-radius: 50%;
        font-size: 10px;
        font-weight: 600;
        line-height: 1;
        color: #fff;
        cursor: default;
        user-select: none;
      }

      .senderAvatarAgent {
        @include themify($themes) {
          background: themed("brand-primary");
        }
      }

      .senderAvatarBot {
        background: #6b7280;
      }
    }
  }

  .contrastTime:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    height: 28px;
    width: 100%;
    border-radius: 0 0 8px 8px;
    background-image: linear-gradient(to top, rgba(11, 20, 26, 0.5), rgba(11, 20, 26, 0));
  }

  .messageOut {
    @include themify($themes) {
      background: #ccf9da;
      @include dark-mode() {
        background-color: #005c47;
        display: none;
      }
    }
  }

  .messageEdited {
    pointer-events: all;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  &.templateMessage.messageRowOut {
    @include themify($themes) {
      .messageOut {
        background-color: #dbe8ff;
        @include dark-mode() {
          background-color: themed("brand-primary");
        }

        &.message.withTail::before {
          border-top-color: #dbe8ff;
          @include dark-mode() {
            border-top-color: themed("brand-primary");
          }
        }
      }
      .inlineActionsWrapper {
        background: radial-gradient(at top right, hex-to-rgba(#dbe8ff) 60%, hex-to-rgba(#dbe8ff, 0) 80%);
        @include dark-mode() {
          background: radial-gradient(at top right, hex-to-rgba(themed("brand-primary")) 60%, hex-to-rgba(themed("brand-primary"), 0) 80%);
        }
      }
    }
  }

  .messageIn {
    @include themify($themes) {
      background: themed("main-secondary");
    }
  }

  .message {
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.15));
    position: relative;
    display: flex;
    width: fit-content;
    flex-direction: column;
    padding: 6px 7px 8px 9px;
    margin-top: 4px;
    border-radius: 12px;

    .pinnedDot {
      @include themify($themes) {
        background-color: themed("brand-primary");
      }
      position: absolute;
      top: -5px;
      right: -5px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }

    &.templateMediaMessage {
      width: min(338px, calc(100vw - 72px));
      max-width: 100%;
    }

    &.withTail {
      position: relative;
      margin-top: 12px;

      &.messageOut {
        &.templateMessage::before {
          @include themify($themes) {
            border-top-color: #dbe8ff;
            @include dark-mode() {
              border-top-color: themed("brand-primary");
            }
          }
        }

        &::before {
          @include themify($themes) {
            border-top-color: #ccf9da;
            @include dark-mode() {
              border-top-color: #005c47;
            }
          }
          right: -7px;
        }

        .messageContainer {
          border-top-right-radius: 0;
        }
      }

      &::before {
        position: absolute;
        z-index: 1;
        top: 0;
        width: 0;
        height: 0;
        border-top: 16px solid;
        border-right: 16px solid transparent;
        border-left: 16px solid transparent;
        content: "";
      }

      &.messageIn {
        &::before {
          left: -7px;
          @include themify($themes) {
            border-top-color: themed("main-secondary");
          }
        }

        .messageContainer {
          border-top-left-radius: 0;
        }
      }

      &::before {
        z-index: -1;
      }
    }
  }

  .messageMetaIndicators {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    padding-bottom: 2px;
  }

  .messageMetaIndicator {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-style: italic;
    @include themify($themes) {
      color: themed("neutral-primary");
      @include dark-mode() {
        color: rgba(255, 255, 255, 0.6);
      }
    }

    svg {
      flex-shrink: 0;
    }
  }

  .messageSenderReceiver {
    @include themify($themes) {
      color: themed("neutral-primary");
      @include dark-mode() {
        color: rgba(255, 255, 255, 0.6);
      }
      .senderIsTuvisSystem {
        color: themed("main-primary");
        font-weight: bold;
        font-size: 12px;
      }
    }
    display: flex;
    align-items: center;
    font-size: 10px;
    font-weight: 500;
    user-select: none;

    & > svg {
      margin: 0 2px;
    }

    & > span {
      cursor: pointer;
    }

    & > a {
      text-decoration: underline;
      @include themify($themes) {
        color: themed("neutral-primary");
        @include dark-mode() {
          color: rgba(255, 255, 255, 0.6);
        }
      }

      &.noLink {
        text-decoration: none;
      }
    }
  }

  .messageText {
    white-space: pre-line;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    text-align: start;
    word-break: break-word;
    @include themify($themes) {
      color: themed("main-primary");
    }
  }

  .disappearingMessageContainer {
    display: flex;
    align-items: center;
    gap: 6px;
    opacity: 0.5;
  }

  &:hover {
    .messageFloatingActions {
      display: flex;

      @include mobile() {
        display: none;
      }
    }
  }

  .callRecordingIndicator {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.messageRowOut {
  justify-content: end;

  .messageFloatingActions {
    right: calc(100% + 12px);
  }

  @include themify($themes) {
    .inlineActionsWrapper {
      background: radial-gradient(at top right, hex-to-rgba(#ccf9da) 60%, hex-to-rgba(#ccf9da, 0) 80%);
      @include dark-mode() {
        background: radial-gradient(at top right, hex-to-rgba(#005c47) 60%, hex-to-rgba(#005c47, 0) 80%);
      }
    }
  }
}

.messageRowIn {
  justify-content: start;

  .messageFloatingActions {
    left: calc(100% + 12px);
    flex-direction: row-reverse;
  }

  @include themify($themes) {
    .inlineActionsWrapper {
      background: radial-gradient(at top right, hex-to-rgba(themed("main-secondary")) 60%, hex-to-rgba(themed("main-secondary"), 0) 80%);
    }
  }
}

.messageSentTime {
  pointer-events: none;
  font-size: 11px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: -3px;
  gap: 3px;

  &.contrast {
    position: absolute;
    right: 12px;
    bottom: 12px;
    color: #fff !important;
  }

  @include themify($themes) {
    color: themed("neutral-primary");
    @include dark-mode() {
      color: #ffffff80;
    }
  }
}

.timeWithSpan {
  display: block;
  min-width: 38px;

  &.editedSpan {
    min-width: 75px;
  }
}

.textContainer {
  display: flex;
}

.noLink {
  text-decoration: none;
}

.fileImage {
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  overflow: hidden;

  &.withTail {
    margin-top: 2px;
  }

  &:not(.contrastTime) {
    margin-bottom: 5px;
  }

  img {
    border-radius: 8px;
  }

  .message.templateMediaMessage & {
    width: 100%;
    aspect-ratio: 16 / 9;
    align-self: stretch;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}

.fileImageWrapper {
  overflow: hidden;
}

.fileVideoPreview {
  width: 100%;
  position: relative;
  cursor: pointer;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.withTail {
    margin-top: 2px;
  }

  &:not(.contrastTime) {
    margin-bottom: 5px;
  }

  img {
    max-width: 330px;
    max-height: 330px;
    border-radius: 8px;
  }

  .message.templateMediaMessage & {
    aspect-ratio: 16 / 9;
    height: auto;

    img {
      max-width: none;
      max-height: none;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .playButtonContainer {
    position: absolute;
    top: 0;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .playButton {
    display: flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.25s ease-in;

    @include themify($themes) {
      background-color: rgba(0, 0, 0, 0.2);
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    svg {
      color: #ffffff;
    }
  }
}

.fileGeneric {
  display: flex;
  align-items: center;
  padding: 12px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin-bottom: 5px;
  position: relative;

  &.withTail {
    margin-top: 2px;
  }

  .fileIcon {
    margin-right: 12px;
    flex-shrink: 0;
  }

  .fileContent {
    flex: 1;
    min-width: 0;
  }

  .fileName {
    font-size: 13px;
    font-weight: 400;
    @include themify($themes) {
      color: themed("main-primary");
    }
  }

  .fileDetails {
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
    line-height: 15px;

    > span:not(:last-child) {
      margin-right: 6px;
    }

    @include themify($themes) {
      color: themed("font_secondary");
    }
  }
}

.warningButton {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #ff9800;
  }
}

.messageTextAfterFile {
  margin-top: 8px;
}

.downloadFile,
.crmIcon,
.playFileButton {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  border-radius: 50%;
  cursor: pointer;

  @include themify($themes) {
    border: 2px solid themed("neutral-primary");
  }

  svg {
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }
}

.warningButton {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: #ff9800;
  }
}

.messageTextAfterFile {
  margin-top: 8px;
}

.downloadFile,
.playFileButton {
  padding: 6px;
}

.downloadFile {
  svg {
    transform: rotate(90deg);
  }
}

.videoModalBackdrop {
  backdrop-filter: blur(2px);
  display: flex;
  flex-wrap: wrap;
  @include themify($themes) {
    background-color: rgba(themed("main-secondary"), 0.9) !important;
  }
}

.videoModalBackdrop {
  .modalBody {
    max-height: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
}

.editedMessagesModalBackdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10001;
}

.editedModal {
  box-sizing: border-box;
  max-height: calc(100vh - 48px);
  width: min(100%, 520px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px;
  position: relative;
}

.editedModalBody {
  display: flex !important;
  flex: 1 1 auto;
  min-height: 0 !important;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-top: 12px;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.actionsContainer {
  position: absolute;
  top: 15px;
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  align-items: center;

  .modalClose {
    cursor: pointer;
  }

  .modalDownload {
    cursor: pointer;
  }
}

.videoModalContainer {
  position: relative;
  border: unset !important;
  background-color: unset !important;
  display: flex;
  flex-wrap: wrap;
  max-height: calc(100% - 60px);
  height: calc(100% - 60px);

  video,
  img {
    max-width: 440px;
    width: 100%;
    max-height: 100%;
  }
}

.audioPlayerWrapper {
  padding: 6px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin-bottom: 5px;

  &.withTail {
    margin-top: 2px;
  }
}

.messagePreviewModalImageContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
}

.messageLocationPreview {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  height: 150px;
  border-radius: 8px;

  &:not(.contrastTime) {
    margin-bottom: 5px;
  }
}

.messageLocationName {
  @include themify($themes) {
    color: themed("main-primary");
    font-size: 13px;
  }
}

.messagePreviewModalImageContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  img {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
}

.messageContacts {
  display: flex;
  flex-direction: column;
  width: 280px;
  font-size: 15px;
  cursor: pointer;

  .messageContactsHeader {
    position: relative;
    display: flex;
    align-items: center;

    .messageContactsInitials {
      display: flex;
      flex-shrink: 0;
      padding: 15px 10px;

      > div {
        width: 39px;
        height: 39px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 13px;
        position: relative;
        z-index: 2;

        @include themify($themes) {
          color: themed("main-primary");
          border: 2px solid themed("main-secondary");
          background-color: themed("brand-primary");
        }

        &:not(:first-child) {
          margin-left: -30px;
          z-index: 1;
        }
      }
    }
  }

  .messageContactsFooter {
    display: flex;
    padding: 10px 15px 5px;
    align-items: center;
    justify-content: center;
    @include themify($themes) {
      border-top: 1px solid themed("neutral-secondary");
    }
  }
}

.previewContacts {
  width: 500px;
  padding: 0;
  overflow: hidden;

  @include themify($themes) {
    background-color: themed("neutral-tertiary");
    border: 0;
  }

  .previewContactsHeader {
    padding: 15px;
  }

  .previewContactsBody {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 5px 0 30px 0;
  }

  .contactItem {
    @include themify($themes) {
      background-color: themed("main-secondary");
      margin: 20px 0;
      padding: 10px;
      box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);

      &:first-child {
        margin-top: 0;
      }

      .contactHeader {
        display: flex;
        padding: 15px;

        .contactInitial {
          display: flex;
          flex-shrink: 0;
          padding: 15px 10px;
          width: 39px;
          height: 39px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-size: 13px;
          position: relative;
          z-index: 2;
          color: themed("main-primary");
          border: 2px solid themed("main-secondary");
          background-color: themed("brand-primary");
        }

        .contactName {
          font-size: 15px;
          font-weight: 500;
          margin-left: 15px;
        }

        .contactTitle {
          color: themed("neutral-primary");
          font-weight: 400;
          font-size: 13px;
        }
      }

      .contactDetail {
        padding: 15px;
        font-size: 15px;
        border-bottom: 1px solid themed("neutral-secondary");
        display: flex;
        flex-direction: column;
        position: relative;

        &:last-child {
          border-bottom: 0;
        }
      }
      a.contactDetail {
        color: themed("main-primary");
        text-decoration: none;
      }

      .startChat {
        cursor: pointer;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        width: 40px;
        height: 40px;
        padding: 10px;

        &:hover {
          background-color: themed("brand-secondary");
        }
      }

      .contatctType {
        color: themed("brand-alt");
        font-size: 13px;
        margin-top: 3px;
      }
    }
  }
}

.messageFloatingActions {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  display: none;
  column-gap: 6px;
}

.messageFloatingAction {
  height: 28px;
  width: 28px;
  border-radius: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify($themes) {
    background-color: themed("main-secondary");
    @include dark-mode() {
      background-color: themed("neutral-primary");
    }
  }
}

.reactionsContainer {
  position: relative;
  bottom: 4px;
  align-self: flex-end;
  display: flex;
  width: fit-content;
  right: 6px;
  box-shadow:
    0 1px 0 rgba(0, 0, 0, 0.07),
    0 0 3px rgba(0, 0, 0, 0.04);
  border-radius: 50px;
  user-select: none;
  @include themify($themes) {
    background-color: themed("main-secondary");
    border: solid 1px themed("neutral-secondary");
  }
}

.reactions {
  height: 26px;
  margin: 0 2px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reactionsCustomTooltipWrapper {
  position: absolute;
  left: calc(100% + 8px);
  border-radius: 8px;
  top: 50%;
  transform: translate(0, -50%);
  filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.15));
  z-index: 2;
  overflow: hidden;

  @include themify($themes) {
    background-color: themed("main-secondary");
    border: solid 1px themed("neutral-secondary");
  }

  &.messageIsSent {
    left: unset;
    right: calc(100% + 8px);
  }

  .reactionsCustomTooltipContainer {
    position: relative;
    width: 250px;
  }
}

.reactionTooltipContentWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;

  &.hoverEffect {
    transition: background-color 0.25s ease-out;
    cursor: pointer;

    &:hover {
      transition: background-color 0.25s ease-in;
      @include themify($themes) {
        background-color: rgba(themed("neutral-primary"), 0.5);
      }
    }
  }

  &.borderBottom {
    @include themify($themes) {
      border-bottom: solid 1px themed("neutral-secondary");
    }
  }
}

.reactionCustomTooltipEmoji {
  font-size: 28px;
}

.clickToRemoveText {
  font-size: 12px;
  margin-top: 4px;

  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.inlineActionsWrapper {
  display: none;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 0;
  width: 27px;
  height: 27px;
  align-items: flex-end;
  z-index: 4;
  border-radius: 12px;
  padding-right: 6px;

  &.isOpen {
    display: flex;
  }
}

.messageRow {
  &.disableActions {
    .inlineActionsContainer,
    .inlineActionsWrapper,
    .messageFloatingActions {
      display: none;
    }

    &:hover {
      .inlineActionsContainer,
      .inlineActionsWrapper,
      .messageFloatingActions {
        display: none;
      }
    }
  }
}

.inlineActionsContainer {
  position: absolute;
  display: none;
  user-select: none;
  max-width: 340px;
  border-radius: 12px;
  box-shadow:
    0 2px 5px 0 rgba(11, 20, 26, 0.26),
    0 2px 10px 0 rgba(11, 20, 26, 0.16);
  padding: 9px 0;
  z-index: 100;
  top: -58px;
  min-width: 160px;
  left: calc(100% - 24px);
  @include themify($themes) {
    background-color: themed("main-secondary");
    @include dark-mode() {
      background-color: themed("neutral-tertiary");
      color: themed("main-primary");
    }
  }

  &.inlineActionsAreOpen {
    display: flex;
    flex-direction: column;
  }

  &.openToTheLeft {
    right: 0;
    left: unset;
  }

  &.openToBottom {
    top: 18px;
  }
}

.inlineActionsArrow {
  cursor: pointer;
}

.inlineAction {
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 14.5px;
  line-height: 14.5px;
  white-space: nowrap;
  text-transform: capitalize;
  cursor: pointer;
  padding: 12px;
  margin: 0 12px;
  width: calc(100% - 24px);
  border-radius: 12px;
  transition: background-color 0.25s ease-out;

  &:hover {
    transition: background-color 0.25s ease-in;
    @include themify($themes) {
      background-color: themed("neutral-tertiary");
      @include dark-mode() {
        background-color: themed("main-secondary");
      }
    }
  }

  &.isFloatingAction {
    display: none;

    @include mobile() {
      display: flex;
    }
  }
}

// Internal notes — centered system messages
.internalNoteRow {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 6px 36px;
}

.internalNote {
  max-width: 85%;
  min-width: 200px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  border-left: 3px solid;

  @include themify($themes) {
    background: rgba(themed("brand-primary"), 0.06);
    border-left-color: themed("brand-primary");
    color: themed("main-primary");
  }
}

.internalNoteLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;

  @include themify($themes) {
    color: themed("brand-primary");
  }
}

.internalNoteText {
  text-align: start;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.5;

  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.internalNoteDatetime {
  font-size: 10px;
  margin-top: 6px;
  text-align: end;

  @include themify($themes) {
    color: themed("neutral-primary");
    opacity: 0.5;
  }
}

// Spoiler mask for fraudulent messages: transparent text under the WhatsApp/Telegram spoiler-dots texture.
.fraudSpoiler {
  display: inline-block;
  cursor: pointer;
  user-select: none;
  color: transparent;
  border-radius: 4px;
  background-image: var(--fraud-bg);
  background-size: auto 8px;
  animation: fraudSpoilerPulse 1.75s linear infinite;

  * {
    color: transparent !important;
    opacity: 0 !important;
    pointer-events: none;
  }
}

@keyframes fraudSpoilerPulse {
  0%,
  100% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.7;
  }
}
